import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { Fab, Tooltip, Button } from "@mui/material"
import { MapContext } from "../../../store/context";
import { useContext, useEffect, useState } from "react";
import { MakeSwap } from "../../../utils/MapUtils";
import MenuItem from '@mui/material/MenuItem';
import SwapHorizontalCircleOutlinedIcon from '@mui/icons-material/SwapHorizontalCircleOutlined';
import InfoIcon from '@mui/icons-material/Info';
import { StyledMenu } from "./MenuStyle";

export default function SwapBlocks() {
    const ctx = useContext(MapContext)
    const plan = ctx.plan
    const map = ctx.map
    const level = ctx.level
    const mapSettings = ctx.settings
    const [fromBlock, setFromBlock] = useState(null)
    const [toBlock, setToBlock] = useState(null)
    const [color, setColor] = useState('primary')
    const [anchorEl, setAnchorEl] = useState(null)
    const [swapActive, setSwapActive] = useState(false)

    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const handleSwapActive = () => {
        setSwapActive(!swapActive)
        setColor(swapActive ? 'primary' : 'secondary')
        setAnchorEl(null)
    }

    useEffect(() => {
        if (swapActive) {
            map.dragPan.disable()
            map.on('mousedown', 'plan-layer', (e) => {
                setFromBlock(e.features[0].properties.blockgeo_id)
            })

            map.on('mouseup', 'plan-layer', (e) => {
                setToBlock(e.features[0].properties.blockgeo_id)
            })
        } else {
            map.dragPan.enable()
        }
    }, [swapActive])

    useEffect(() => {
        if (fromBlock && toBlock && swapActive) {
            MakeSwap(map, plan, level, fromBlock, toBlock)
            setFromBlock(null)
            setToBlock(null)
        }
    }, [fromBlock, toBlock, swapActive])

    return (
        <>
            <Button>
                <Fab size='medium' disabled={false} color={color} onClick={handleClick}>
                    <SwapHorizIcon color='#000' />
                </Fab>
            </Button>
            <StyledMenu anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={{ marginLeft: '1em' }}
            >
                <MenuItem onClick={handleSwapActive}>
                    {swapActive ? (
                        <Tooltip title='Drag and swap a block.' placement='right'>
                            <SwapHorizIcon />
                        </Tooltip>
                    ) : (
                        <Tooltip title='Drag and swap a block.' placement='right'>
                            <SwapHorizontalCircleOutlinedIcon />
                        </Tooltip>
                    )}

                </MenuItem>
                <MenuItem>
                    <Tooltip title='Drag a block from one school zone to another to perform a swap' placement='right'>
                        <InfoIcon />
                    </Tooltip>
                </MenuItem>
            </StyledMenu>
        </>
    )
}